import React, { useState, useEffect, useCallback } from "react";
import ThemeContext, { AdminTheme } from "@/context/ThemeContext";

const THEME_KEY = "admin_theme";

const ALL_BASE_CLASSES = [
  "dark",
  "ocean",
  "navy",
  "cobalt",
  "teal",
  "turquoise",
  "forest",
  "emerald",
  "sage",
  "seafoam",
  "slate",
  "grape",
  "rose"
];

function applyTheme(theme: AdminTheme) {
  const html = document.documentElement;
  html.classList.remove(...ALL_BASE_CLASSES);

  if (theme === "light") {
    // default: no extra classes
  } else if (theme === "dark") {
    html.classList.add("dark");
  } else if (theme.endsWith("-dark")) {
    const base = theme.replace(/-dark$/, "");
    html.classList.add(base, "dark");
  } else {
    html.classList.add(theme);
  }
}

export default function ThemeProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [theme, setThemeState] = useState<AdminTheme>(() => {
    try {
      return (localStorage.getItem(THEME_KEY) as AdminTheme) || "light";
    } catch {
      return "light";
    }
  });

  useEffect(() => {
    applyTheme(theme);
  }, [theme]);

  const setTheme = useCallback((next: AdminTheme) => {
    try {
      localStorage.setItem(THEME_KEY, next);
    } catch {}
    setThemeState(next);
    applyTheme(next);
  }, []);

  return (
    <ThemeContext.Provider value={{ theme, setTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}
